import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panels-wrapper" }
const _hoisted_2 = {
  class: "left-wrapper",
  style: {"outline":"none"},
  tabindex: "0"
}

import { ref, computed } from 'vue';
import InfoPanel from '../components/InfoPanel.vue';
import NewSessionModal from '../components/NewSessionModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseView',
  setup(__props) {

const infoPanelOpen = ref<boolean>(false),
      settingsShowMainMenu = ref<boolean>(true),
      activeSidePanel = ref<string | null>(null),
      PANEL_SETTINGS = ref<string>("SETTINGS"),
      newSessionModalVisible = ref<boolean>(false),
      screenRecorderDisabled = ref<boolean>(false),
      shouldCloseInfoPanel = ref<boolean>(false);

const settingsOpen = computed(
  () => activeSidePanel.value === PANEL_SETTINGS.value
);

function closeSettings() {
  if (shouldCloseInfoPanel.value) {
    infoPanelOpen.value = false;
  }
  activeSidePanel.value = null;
  settingsShowMainMenu.value = true;
}

function toggleSettingsOpen() {
  if (!settingsOpen.value) {
    if (!infoPanelOpen.value) {
      infoPanelOpen.value = true;
      shouldCloseInfoPanel.value = true;
    }
    activeSidePanel.value = PANEL_SETTINGS.value;
  } else {
    closeSettings();
  }
}

function toggleInfoPanelOpen() {
  infoPanelOpen.value = !infoPanelOpen.value;
  shouldCloseInfoPanel.value = false;
}

function setNewSessionModalVisible(visible: boolean) {
  newSessionModalVisible.value = visible;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InfoPanel, {
        class: "info-panel",
        isOpen: infoPanelOpen.value,
        toggleInfoPanelOpen: toggleInfoPanelOpen,
        toggleSettingsOpen: toggleSettingsOpen,
        sessionBrowserPage: "",
        openNewSessionModal: setNewSessionModalVisible
      }, null, 8, ["isOpen"])
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(NewSessionModal, {
      visible: newSessionModalVisible.value,
      setVisible: setNewSessionModalVisible,
      screenRecorderDisabled: screenRecorderDisabled.value
    }, null, 8, ["visible", "screenRecorderDisabled"])
  ]))
}
}

})